import React, { Component } from 'react';
import { connect } from 'react-redux';

import HowToReturnItem from './HowToReturnItem';

import { flagEnabled } from '../helpers/featureFlags';
import { RETURNS_LABEL, subst } from '../helpers/routes';

const renderItems = items => (
  items.map((item = {}) => (
    <HowToReturnItem key={item.title} item={item} />
  ))
);

class HowToReturn extends Component {
  toggleDetails() {
    const { expanded } = this.state;

    this.setState({
      expanded: !expanded,
    });
  }

  render() {
    const { trackingId } = this.props;

    const upsCallForPickup = flagEnabled('device-returns.upsCallForPickup', { defaultValue: true });
    const getContent = (context) => {
      if (context === 'xfinityStore') {
        return [
          {
            title: '1. Unplug Your Equipment',
            content: 'Disconnect all devices you want to return. You can also return additional items (like cables, remote controls, and power supply cords) that you\'re no longer using.',
            icon: 'devices-80',
          },
          {
            title: '2. Drop Off at an Xfinity Store',
            content: 'Bring your equipment to one of our stores and our team will help you complete your return.',
            linkHref: 'https://www.xfinity.com/support/service-center-locations?retail=true',
            linkTarget: '_blank',
            linkText: 'Find an Xfinity Store',
            icon: 'map-pin-80',
            hardCodedURL: true,
          },
        ];
      }

      const selectMethodString = 'Print your return label from the confirmation page on the next step and tape it to the box.';
      const detailString = 'Print and attach the label to the top of the box.';

      return [
        {
          title: '1. Pack Your Devices in a Box',
          content: 'You can use bubble wrap or newspaper as padding.',
          buttonText: 'Packing Details',
          icon: 'box-open-80',
          details: [
            '<b>Disconnect</b> all devices you want to return',
            '<b>Pack</b> device(s) securely in a cardboard box with bubble wrap or padding. You can also include additional items (cables, remote controls, power cords, etc.) that you\'re no longer using.',
            '<b>Seal</b> the box using tape',
            '<b>Remove</b> any old labels from the box',
          ],
          clickAction: this.toggleDetails,
        },
        {
          title: '2. Print Prepaid Label',
          content: `${(context === 'selectMethod') ? selectMethodString : detailString}<br />`,
          icon: 'printer-80',
          linkTarget: '_blank',
          linkHref: trackingId ? `${subst(RETURNS_LABEL, { id: trackingId })}` : undefined,
          linkText: 'Print Shipping Label',
        },
        {
          title: upsCallForPickup ? '3. Call 1-800-PICK-UPS to arrange at-home pickup, or visit The UPS Store' : '3. Drop Off at a UPS Store',
          content: (
            upsCallForPickup ? `You can also handoff to any UPS driver that is in the neighborhood on a delivery route.<br />
            <small>Please note packages should <b>not</b> be returned using a UPS Drop Box.</small>`
              : `Drop off the package at a UPS Store or any authorized UPS Service Center.<br />
            <small>Please note packages should <b>not</b> be returned using a UPS Drop Box.</small>`
          ),
          linkTarget: '_blank',
          linkHref: 'https://www.theupsstore.com/tools/find-a-store',
          linkText: 'Find a UPS Store',
          icon: 'map-pin-80',
          hardCodedURL: true,
        },
      ];
    };

    const { hideTitle, context } = this.props;

    const stepContent = getContent(context);

    return (
      <>
        {!hideTitle && (
          <div className="card-group__item">
            <div className="card">
              <div className="card__content">
                <h2 className="heading3">How to Return</h2>
              </div>
            </div>
          </div>
        )}
        {renderItems(stepContent)}
      </>
    );
  }
}

const mapStateToProps = state => ({
  trackingId: state.order.trackingId,
});

export default connect(mapStateToProps)(HowToReturn);
